var React = require('react');

function ArrowRight2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.65332 6.48083L3.13415 4L0.65332 1.51375L1.41707 0.75L4.66707 4L1.41707 7.25L0.65332 6.48083Z","fill":"currentColor"}));
}

ArrowRight2.defaultProps = {"width":"5","height":"8","viewBox":"0 0 5 8","fill":"none"};

module.exports = ArrowRight2;

ArrowRight2.default = ArrowRight2;
